import { configureStore } from '@reduxjs/toolkit';
import { useDispatch } from 'react-redux';
import { apiSlice } from '../features/api/api';
import calendarReducer from '../features/calendar/calendar-slice';
import settingsReducer from '../features/settings/settings-slice';


export const store = configureStore({
    reducer: {
        calendar: calendarReducer,
        settings: settingsReducer,
        [apiSlice.reducerPath]: apiSlice.reducer,
    },
    middleware: (getDefaultMiddleware) => {
        return getDefaultMiddleware().concat([
            apiSlice.middleware
        ]);
    }
});

export type AppDispatch = typeof store.dispatch;
export const useAppDispatch: () => AppDispatch = useDispatch;
export type RootState = ReturnType<typeof store.getState>;

export default store;